module.exports = __webpack_public_path__ + "img/inco2.cde36a3c.png";